<app-type-attribution-marche-lot [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
    [attribue]="resultat.attribue" [errorMessagePersonneMoral]="{'required' : 'ctr_303'}" [type]="type" [index]="index"></app-type-attribution-marche-lot>
    <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1 + index" [id]="getStepId() + rg1 + index"></app-form-input-error>
